export const formatAiResponse = (raw: string): string => {
	if (!raw) return ''

	let rest = raw.trim()

	while (rest.startsWith('[')) {
		let depth = 0
		let end = -1

		for (let i = 0; i < rest.length; i += 1) {
			const ch = rest[i]
			if (ch === '[') depth += 1
			if (ch === ']') {
				depth -= 1
				if (depth === 0) {
					end = i
					break
				}
			}
		}

		if (end === -1) break
		rest = rest.slice(end + 1).trim()
	}

	const cleaned = rest.replace(/\r\n/g, '\n').trim()

	return cleaned
		.split(/\n{2,}/)
		.map(block => block.replace(/ \u2022 /g, '\n• '))
		.map(block =>
			block
				.split('\n')
				.map(line => line.trim())
				.filter(Boolean)
				.join('<br>')
		)
		.filter(Boolean)
		.map(content => `<p>${content}</p>`)
		.join('\n')
}
